export default __webpack_public_path__ + "static/media/desenfoque.c29f555f.png";